
import React, { memo } from 'react';
import { cn } from '@/lib/utils';
import ImageOptimizer from './ImageOptimizer';

interface AnimatedLogoProps {
  className?: string;
}

// Memoize to prevent unnecessary re-renders
const AnimatedLogo: React.FC<AnimatedLogoProps> = memo(({ className }) => {
  return (
    <div className={cn("flex items-center justify-center", className)}>
      <ImageOptimizer 
        src="/lovable-uploads/5f317969-c550-4e59-9f51-0c65b8c1d927.png" 
        alt="Titan Prediction Logo" 
        className="w-10 h-10 object-contain dark:filter dark:brightness-0 dark:invert"
        priority={true} // Logo should load with priority as it's in the critical path
      />
    </div>
  );
});

AnimatedLogo.displayName = 'AnimatedLogo';

export default AnimatedLogo;
